import { render, staticRenderFns } from "./PhoneVerifyModal.vue?vue&type=template&id=a91b12d8&scoped=true"
import script from "./PhoneVerifyModal.vue?vue&type=script&lang=js"
export * from "./PhoneVerifyModal.vue?vue&type=script&lang=js"
import style0 from "./PhoneVerifyModal.vue?vue&type=style&index=0&id=a91b12d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a91b12d8",
  null
  
)

export default component.exports